<template>
<div class="service-content">
  <div class="content">
    <div class="title-name">橡诺简介</div>
    <div class="title-sub">
      上海橡诺科技有限公司是值得信赖的咨询与科技服务提供商，总部位于中国上海。公司拥有较强的运营能力、严格的质量标准和高效的交付流程，致力于成为中国企业“互联网+时代的合作伙伴”，为您的成功保驾护航。<br><br>
      上海橡诺科技有限公司注册资金为人民币1000万。<br><br>
      自2014年以来，橡诺科技一直致力于为客户提供领先的商业/IT咨询、解决方案以及外包服务，在金融服务、高科技、房地产、游戏等领域积累了丰富的行业经验，主要客户涵盖众多金融机构，银行，证券，基金，第三方支付，养老，房地产，游戏等大中小企业。<br><br>
      凭借专业的交付能力，橡诺科技帮助客户在全球市场中赢得成功，并且获得合作伙伴的高度认可。橡诺科技是互联网+时代的信息技术咨询和外包服务行业的创新型企业。<br><br>
      公司将为成为“互联网+”时代优秀的软件应用咨询和外包服务商的目标而奋斗；并继续秉承积极务实、勇于创新的精神为行业的发展贡献自己的先进经验。<br><br>
      橡诺科技的服务基于公司在各行业中企业应用产品咨询, 重大技术以及与全球性组织的多年合作中进行经验积累的结果。我们所拥有的专业经验、资源和行业知识能够保证我们及时并高质量地交付来自客户对资源要求最严格、时间最紧急的项目。橡诺科技已建立了多种能够最大限度提高客户投资回报的系统化、成熟的应用软件开发和维护模式。<br><br>
      橡诺科技致力于为政府、金融服务业、IT高科技行业、房地产业等领域的客户提供IT解决方案。我们将解决方案定位于商务和科技完美结合的动态环境中，从而为客户提供高质量的服务，满足客户在规模、效率、质量、专业能力等全方位的要求，帮助企业客户勾画并实现技术驱动的商业变革和创新。
    </div>
  </div>
  <Mission/>
</div>
</template>

<script>
import Mission from '@/components/Mission'
export default {
  name: '',
  components: {
    Mission
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    overflow: visible;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      overflow: visible;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        // width: 1039px;
        color: #666;
        transform: .5s;
        line-height: 24px;
        // text-align: center;
        font-size: 16px;
        box-sizing: border-box;
      }
    }
}
</style>
